module.exports = __webpack_public_path__ + "img/CM-AB-24-INFINITI-Playful.d20bab85.jpg";